export default __webpack_public_path__ + "static/worksBg2-ff1b16321c49f12d26300ce67e455e3c.jpg";